import { defineNuxtPlugin, type NuxtApp } from 'nuxt/app'
import { logs, SeverityNumber } from '@opentelemetry/api-logs'

const otelLogger = logs.getLogger('sec-auditor-web-browser')

export default defineNuxtPlugin(() => {
  const envVars = useRuntimeConfig()
  const nuxtApp: NuxtApp = useNuxtApp()

  function error (e: unknown): void {
    if (e instanceof Error) {
      nuxtApp.$sentry.captureException(e)
    } else {
      nuxtApp.$sentry.captureMessage(String(e))
    }

    otelLogger.emit({ severityNumber: SeverityNumber.ERROR, severityText: 'ERROR', body: e instanceof Error ? e.message : String(e) })

    if (envVars.public.ENVIRONMENT === 'next' || envVars.public.ENVIRONMENT === 'dev') {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  function warn (e: unknown): void {
    if (e instanceof Error) {
      nuxtApp.$sentry.captureException(e)
    } else {
      nuxtApp.$sentry.captureMessage(String(e))
    }

    otelLogger.emit({ severityNumber: SeverityNumber.WARN, severityText: 'WARN', body: e instanceof Error ? e.message : String(e) })

    if (envVars.public.ENVIRONMENT === 'next' || envVars.public.ENVIRONMENT === 'dev') {
      // eslint-disable-next-line no-console
      console.warn(e)
    }
  }

  function success (e: unknown): void {
    otelLogger.emit({ severityNumber: SeverityNumber.INFO, severityText: 'INFO', body: String(e) })

    if (envVars.public.ENVIRONMENT === 'next' || envVars.public.ENVIRONMENT === 'dev') {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  function info (e: unknown): void {
    otelLogger.emit({ severityNumber: SeverityNumber.INFO, severityText: 'INFO', body: String(e) })

    if (envVars.public.ENVIRONMENT === 'next' || envVars.public.ENVIRONMENT === 'dev') {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  const logger = { error, warn, success, info }
  return {
    provide: {
      logger
    }
  }
})
